// project settings, you can change only PROJECT_NAME, BASE_URL and WEBSITE_URL otherwise it can break the app
export const PROJECT_NAME = 'Foodyman marketplace';
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://api.foodyman.org';
export const WEBSITE_URL = 'https://foodyman.org';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL =
  process.env.REACT_APP_IMG_URL || BASE_URL + '/storage/images/';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';

export const MAP_API_KEY = 'MAP_API_KEY';
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1IjoiZGVsaXZpcCIsImEiOiJjbW1vNXViaDQwN3F2MnFxdDRwZWEwaDVvIn0.eSJVIMHJ9AULpKIIx8c-mg';

export const VAPID_KEY = 'VAPID_KEY';
export const API_KEY = 'API_KEY';
export const AUTH_DOMAIN = 'AUTH_DOMAIN';
export const PROJECT_ID = 'PROJECT_ID';
export const STORAGE_BUCKET = 'STORAGE_BUCKET';
export const MESSAGING_SENDER_ID = 'MESSAGING_SENDER_ID';
export const APP_ID = 'APP_ID';
export const MEASUREMENT_ID = 'MEASUREMENT_ID';

export const RECAPTCHASITEKEY = 'RECAPTCHASITEKEY';
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export const LAT = 47.4143302506288;
export const LNG = 8.532059477976883;
export const DEMO_SELLER = 334;
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0';
export const DEMO_SHOP = 599;
export const DEMO_DELIVERYMAN = 375;
export const DEMO_MANEGER = 114;
export const DEMO_MODERATOR = 297;
export const DEMO_ADMIN = 107;
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
